import { httpBus } from '@/api/httpBus/index.js'



/**
 * 获取eLink 列表
 * @returns 
 */
export function elinks(station_id, status) {
  return httpBus.request("get", `/strategy/api/station/elinks`, {
    params: {
      station_id,
      status
    }
  });
}

/**
 * 获取充放电计划
 * @returns 
 */
export function getPlan(elink_id, begin_date, end_date) {
  return httpBus.request("get", `/strategy/api/station/elink/strategy`, {
    params: {
      elink_id,
      begin_date,
      end_date
    }
  });
}

// 获取eLink
export const get = elink_id => {
  return httpBus.request("get", "/strategy/api/station/elink", {
    params: { elink_id }
  });
};

// 新增eLink
export const add = elink => {
  return httpBus.request("post", "/strategy/api/station/elink", {
    data: elink
  });
};

// 修改eLink
export const update = elink => {
  return httpBus.request("put", "/strategy/api/station/elink", {
    data: elink
  });
};
// 删除eLink
export const del = elink_id => {
  return httpBus.request("delete", "/strategy/api/station/elink", {
    params: { elink_id }
  });
};
// 修改充放电计划
export const updatePlan = (data,smsCode) => {
  if(smsCode){
    return httpBus.request("put", "/strategy/api/station/elink/strategy", {
      data,
      headers: {
        smsCode: smsCode
      }
    });
  }else{
    return httpBus.request("put", "/strategy/api/station/elink/strategy", {
      data
    });
  }
  
};

// 修改eLinkId
export const updateElinkId = (id, elink_id) => {
  return httpBus.request("put", "/strategy/api/station/elink/id", {
    data: { id, elink_id }
  });
};

// 下发策略
export const strategyDown = elinkId => {
  return httpBus.request(
    "post",
    "/strategy/api/station/elink/strategy/down",
    {
      data: { elink_id: elinkId }
      
    },
   
  );
};

// 查看策略历史
export const strategyHistory = (station_id, elink_id, page_num, page_size) => {
  return httpBus.request("get", "/strategy/api/station/elink/strategy/log", {
    params: { station_id, elink_id, page_size, page_num }
  });
};

// 查询某日策略
export const getStrategyByDate = (elink_id, date) => {
  return httpBus.request("get", "/strategy/history/elink", {
    params: { elink_id, date }
  });
};

/**
 * 查询某日实际运行过的历史策略
 *
 * 历史日期（今天之前）的唯一真相源：返回什么展示什么，没有返回就不展示，
 * 前端不再用预约策略 / 设备当前策略去推算历史
 * @param {string} elink_id 设备ID
 * @param {string} date 查询日期，格式 yyyy-MM-dd
 */
export const getRunningHistory = (elink_id, date) => {
  return httpBus.request("get", "/strategy/history/running", {
    params: { elink_id, date }
  });
};

/**
 * 查询所选天数的设备执行的自定义策略
 * @param {*} elink_id 
 * @param {*} execution_time 
 */
export function queryCustomStrategyByDay(elink_id, execution_time) {
  return httpBus.request("get", "/strategy/elink/custom/strategy/day", {
    params: {
      elink_id,
      execution_time,
    }
  });
}


/**
 * 查询设备的自定义策略列表
 * @param {*} elink_id 
 * @returns 
 */
export function getCustomStrategy(elink_id) {
  return httpBus.request("get", "/strategy/elink/custom/strategy", {
    params: {
      elink_id,
    }
  });
}


/**
 * 添加自定义策略
 * @param {*} strategyData 
 * @returns 
 */
export function postCustomStrategy(strategyData) {
  return httpBus.request("post", "/strategy/elink/custom/strategy", {
    data: strategyData,
  });
}


/**
 * 修改自定义策略 
 * @param {*} strategyData 
 * @returns 
 */
export function putCustomStrategy(strategyData) {
  return httpBus.request("put", "/strategy/elink/custom/strategy", {
    data: strategyData,
  });
}


/**
 * 删除自定义策略 
 * @param {*} id 自定义策略的主键ID
 * @param {*} opt_user 操作者
 * @returns 
 */
export function deleteCustomStrategy(id, opt_user) {
  return httpBus.request("delete", "/strategy/elink/custom/strategy", {
    data: {
      id,
      opt_user
    }
  });
}



/** 获取elink分组策略 */
export function getGroupSettingList(stationId) { 
  return httpBus.request("get", "/strategy/station/groupSettingList", {
    params: { stationId }
  });
}

/**获取站级配置参数 */
export function getStationSetting(stationId) { 
  return httpBus.request("get", "/strategy/station/getStationSetting", {
    params: { stationId }
  });
}


// 修改参数接口（需量、防逆流、无功、通信超时储能工作模式）
export function updateGroupSetting(data,smsCode) {
  return httpBus.request("POST", "/strategy/station/groupSetting", {
    data,
    headers: {
      smsCode: smsCode
    }
  });
}

// 获取参数下发时的短信验证码
export function getSmsCode(phoneNumber) {
  return httpBus.request("GET", "/strategy/station/getSmsCode", {
    params: { phoneNumber }
  });
}



// 判断是否有权限
export function getStationStrategyConfig(stationId) {
  return httpBus.request("GET", `/device/v2/station/strategy/config/${stationId}`);
}


// 获取高级配置操作日志
export function getGroupSettingRecord(data) {
  return httpBus.request("GET", "/strategy/station/getGroupSettingRecord",{params: data});
}

// 校验验证码
export function checkSmsCodeSilent(data) {
  return httpBus.request("GET", "/strategy/station/checkSmsCode", {
    params: data,
    beforeResponseCallback: (response) => {
      // 自定义响应处理，拦截 500 错误
      if (response.data.code === 500) {
        return { code: 500, silent: true };
      }
      return response.data;
    }
  });
}

// 获取设备返回的分组配置信息
export function getAutoDemandConfig(sign) {
  return httpBus.request("GET", "/command/config/getReceiveRecord", {
    params: { sign }
  });
}

// 更新自动需量配置
export function updateAutoDemandConfig(data) {
  return httpBus.request("POST", "/command/config/groupSetting", {
    data
  });
}

// 获取自动需量历史记录
export function getStationConfigReceiveRecord(params) {
  return httpBus.request("GET", "/command/config/getStationConfigReceiveRecord", {
    params: params
  });
}



/**
 * 修改电站配置
 * @param {object} station
 * @returns {Promise<AxiosResponse>}
 */
export function updateAutoDemandValue(stationId, autoDemand) {
  return httpBus.request("put", "/device/station/updateConfig", { 
    data: {
      stationId: stationId,
      autoDemand: autoDemand
    }
  })
}



// 获取能量链温度参数
export const getTempatureOption = uuid => {
  return httpBus.request("get", "/command/device/data/setting", {
    params: { uuid }
  });
};



// 获取能量链温度参数
export const setTempatureOption = data => {
  return httpBus.request("post", "/command/device/command/setting", { data });
};












